import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconContentCut = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M6.427 5.093c.153-.333.24-.7.24-1.093 0-1.473-1.194-2.667-2.667-2.667-1.473 0-2.667 1.194-2.667 2.667 0 1.473 1.194 2.667 2.667 2.667.393 0 .76-.087 1.093-.24L6.667 8 5.093 9.573c-.333-.153-.7-.24-1.093-.24-1.473 0-2.667 1.194-2.667 2.667 0 1.473 1.194 2.667 2.667 2.667 1.473 0 2.667-1.194 2.667-2.667 0-.393-.087-.76-.24-1.093L8 9.333 12.667 14h2v-.667l-8.24-8.24zM4 5.333c-.733 0-1.333-.593-1.333-1.333S3.267 2.667 4 2.667 5.333 3.26 5.333 4 4.733 5.333 4 5.333zm0 8c-.733 0-1.333-.593-1.333-1.333s.6-1.333 1.333-1.333S5.333 11.26 5.333 12s-.6 1.333-1.333 1.333zm4-5c-.187 0-.333-.146-.333-.333 0-.187.146-.333.333-.333.187 0 .333.146.333.333 0 .187-.146.333-.333.333zM12.667 2l-4 4L10 7.333l4.667-4.666V2h-2z"
	})
});
export default SvgIconContentCut;
